(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["depoimentos-realidade"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.drInit) return;
      root.dataset.drInit = '1';

      var track = root.querySelector('.dr__track');
      var prev = root.querySelector('[data-dr-prev]');
      var next = root.querySelector('[data-dr-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.dr__card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }

      function update() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        var x = track.scrollLeft;
        if (prev) prev.hidden = x <= 1;
        if (next) next.hidden = x >= maxScroll;
      }

      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-dr-carousel]').forEach(initCarousel);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lagai-vitrine-abas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.pczInit) return;
      root.dataset.pczInit = '1';
      var track = root.querySelector('.pcz__track');
      var prev = root.querySelector('[data-pcz-prev]');
      var next = root.querySelector('[data-pcz-next]');
      if (!track) return;
      function step() {
        var card = track.querySelector('.pcz__card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      function update() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.hidden = track.scrollLeft <= 1;
        if (next) next.hidden = track.scrollLeft >= maxScroll;
      }
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function init(scope) {
      (scope || document).querySelectorAll('[data-lgva]').forEach(function (root) {
        root.querySelectorAll('[data-pcz-carousel]').forEach(function (c) { if (c.offsetParent !== null) initCarousel(c); });
        if (root.dataset.lgvaInit) return;
        root.dataset.lgvaInit = '1';
        root.addEventListener('click', function (e) {
          var tab = e.target.closest('[data-lgva-tab]');
          if (!tab) return;
          var i = tab.getAttribute('data-lgva-tab');
          root.querySelectorAll('[data-lgva-tab]').forEach(function (t) {
            var on = t === tab; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          root.querySelectorAll('[data-lgva-panel]').forEach(function (p) {
            p.hidden = p.getAttribute('data-lgva-panel') !== i;
            if (!p.hidden) p.querySelectorAll('[data-pcz-carousel]').forEach(initCarousel);
          });
        });
      });
    }
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.pczInit) return;
      root.dataset.pczInit = '1';
      var track = root.querySelector('.pcz__track');
      var prev = root.querySelector('[data-pcz-prev]');
      var next = root.querySelector('[data-pcz-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.pcz__card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      function update() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        var x = track.scrollLeft;
        if (prev) prev.hidden = x <= 1;
        if (next) next.hidden = x >= maxScroll;
      }
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function initAll(scope) {
      (scope || document).querySelectorAll('[data-pcz-carousel]').forEach(initCarousel);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-prints"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTp(scope) {
      (scope || document).querySelectorAll('[data-tp-more]').forEach(function (btn) {
        if (btn.dataset.tpInit) return;
        btn.dataset.tpInit = '1';
        btn.addEventListener('click', function () {
          var tp = btn.closest('.tp');
          if (tp) tp.classList.add('tp--expanded');
        });
      });
    }
    if (document.readyState !== 'loading') initTp();
    else document.addEventListener('DOMContentLoaded', function () { initTp(); });
    document.addEventListener('shopify:section:load', function (e) { initTp(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.ugcInit) return;
      root.dataset.ugcInit = '1';

      var track = root.querySelector('.ugc__track');
      var prev = root.querySelector('[data-ugc-prev]');
      var next = root.querySelector('[data-ugc-next]');
      var focus = root.classList.contains('ugc__carousel--focus');
      if (!track) return;

      function step() {
        var card = track.querySelector('.ugc__card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        var x = track.scrollLeft;
        if (prev) prev.hidden = x <= 1;
        if (next) next.hidden = x >= maxScroll;
      }

      function updateActive() {
        if (!focus) return;
        var cards = track.querySelectorAll('.ugc__card');
        if (!cards.length) return;
        var rect = track.getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var best = null, bestDist = Infinity;
        cards.forEach(function (c) {
          var r = c.getBoundingClientRect();
          var d = Math.abs((r.left + r.width / 2) - center);
          if (d < bestDist) { bestDist = d; best = c; }
        });
        cards.forEach(function (c) { c.classList.toggle('is-active', c === best); });
      }

      function update() { updateArrows(); updateActive(); }

      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-ugc-carousel]').forEach(initCarousel);
    }

    // Lazy video: só carrega/toca o vídeo ao clicar no play (delegação única no documento)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.ugc__play');
      if (!btn) return;
      var facade = btn.closest('[data-ugc-video]');
      var tpl = facade && facade.querySelector('[data-ugc-video-tpl]');
      if (!tpl) return;
      facade.replaceChildren(tpl.content.cloneNode(true));
      var video = facade.querySelector('video');
      if (video && video.play) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    });

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
